import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from "styled-components";
import useApi, {useAuthApi} from "../../hooks/api/axiosInterceptor";
import BoardList from '../../components/BoardList';

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    padding: 2rem;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    text-align: center;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;

const Meta = styled.div`
    font-size: 14px;
    color: gray;
    margin-bottom: 10px;
`;

const Content = styled.p`
    font-size: 16px;
    line-height: 1.6;
`;

const BackButton = styled.button`
    margin-top: 20px;
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
`;



const AutonomyDetail = () => {
    const { category, id } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const b_part = category;

    // 관리자 권한 체크
    useEffect(() => {
        const checkAdminStatus = () => {
            const userRole = localStorage.getItem('user_role') || sessionStorage.getItem('user_role');
            setIsAdmin(userRole === 'admin');
        };

        checkAdminStatus();

        // storage 이벤트 리스너로 권한 변경 감지
        const handleStorageChange = () => {
            checkAdminStatus();
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await useApi.get(`/detail_board?board=${b_part}&id=${id}`);
                if (response.data.result === 'SUCCESS') {
                    setPost(response.data.data);
                } else {
                    console.error("게시물 로드 실패:", response.data.message);
                }
            } catch (error) {
                console.error("API 요청 오류:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPost();
    }, [id]);
    // 목록으로 돌아가기
    const handleBack = () => {
        navigate(`/student-autonomy/${b_part}`);
    };

    // 게시글 수정 (권한이 있는 경우만 표시)
    const handleModify = () => {
        if (isAdmin) {
            navigate(`/student-autonomy/${b_part}/edit/${id}`);
        } else {
            alert('관리자만 수정할 수 있습니다.');
        }    };

    // 게시글 삭제 (권한이 있는 경우만 표시)
    const handleDelete = async () => {
        if (!isAdmin) {
            alert('관리자만 삭제할 수 있습니다.');
            return;
        }

        if (window.confirm('정말로 이 게시글을 삭제하시겠습니까?')) {
            try {
                const response = await useAuthApi.delete(`/delete_board?board=${b_part}&id=${id}`);
                if (response.data.result === 'SUCCESS') {
                    alert('게시글이 삭제되었습니다.');
                    navigate(`/student-autonomy/${b_part}`);
                } else {
                    alert(`삭제 실패: ${response.data.message}`);
                }
            } catch (error) {
                console.error("삭제 요청 오류:", error);
                alert('게시글 삭제에 실패했습니다.');
            }
        }
    };



    if (isLoading) {
        return <p>로딩 중...</p>;
    }

    if (!post) {
        return <p>게시글을 찾을 수 없습니다.</p>;
    }

    return (
        <Wrapper>
            <BoardList
                post={post}
                onBack={handleBack}
                {...(isAdmin && { onModify: handleModify, onDelete: handleDelete })}
                // prevPost={prevPost}
                // nextPost={nextPost}

            />
        </Wrapper>
    );
};






export default AutonomyDetail;
